import { defineComponent as k, openBlock as e, createElementBlock as a, normalizeClass as s, unref as c, createBlock as i, createCommentVNode as l, toDisplayString as m } from "vue";
import t from "@patsnap-biz/icon";
const p = "patsnap-biz-header-widget", d = /* @__PURE__ */ k({
  __name: "HeaderWidget",
  props: {
    icon: {},
    label: {},
    postIcon: {},
    href: {}
  },
  setup(y) {
    const r = y;
    function o(n = []) {
      return [p, ...n].join("__");
    }
    const u = !r.label && (r.icon || r.postIcon);
    return (n, f) => n.href ? (e(), a("a", {
      key: 0,
      class: s([o(), { [`${p}--only-icon`]: c(u) }])
    }, [
      n.icon ? (e(), i(c(t), {
        key: 0,
        icon: n.icon,
        class: s(o(["pre-icon"]))
      }, null, 8, ["icon", "class"])) : l("", !0),
      n.label ? (e(), a("span", {
        key: 1,
        class: s(o(["content"]))
      }, m(n.label), 3)) : l("", !0),
      n.postIcon ? (e(), i(c(t), {
        key: 2,
        icon: n.postIcon,
        class: s(o(["post-icon"]))
      }, null, 8, ["icon", "class"])) : l("", !0)
    ], 2)) : (e(), a("div", {
      key: 1,
      class: s([o(), { [`${p}--only-icon`]: c(u) }])
    }, [
      n.icon ? (e(), i(c(t), {
        key: 0,
        icon: n.icon,
        class: s(o(["pre-icon"]))
      }, null, 8, ["icon", "class"])) : l("", !0),
      n.label ? (e(), a("span", {
        key: 1,
        class: s(o(["content"]))
      }, m(n.label), 3)) : l("", !0),
      n.postIcon ? (e(), i(c(t), {
        key: 2,
        icon: n.postIcon,
        class: s(o(["post-icon"]))
      }, null, 8, ["icon", "class"])) : l("", !0)
    ], 2));
  }
}), g = d;
export {
  g as PtHeaderWidget,
  g as default
};
